import { render, staticRenderFns } from "./unloadingScan.vue?vue&type=template&id=1044a558&scoped=true"
import script from "./unloadingScan.vue?vue&type=script&lang=js"
export * from "./unloadingScan.vue?vue&type=script&lang=js"
import style0 from "./unloadingScan.vue?vue&type=style&index=0&id=1044a558&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1044a558",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/work/jenkins/workspace/重构-快递前端-ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1044a558')) {
      api.createRecord('1044a558', component.options)
    } else {
      api.reload('1044a558', component.options)
    }
    module.hot.accept("./unloadingScan.vue?vue&type=template&id=1044a558&scoped=true", function () {
      api.rerender('1044a558', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/collectionCenter/Operation/carScan/unloadingScan.vue"
export default component.exports